window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

if (window.location.href.includes("tools/bundle-subscriptions") || window.location.href.includes("pages/meal-delivery")) {
  const removeElements = () => {
    const banner = document.querySelector("body.awt-bab-open > .widget-visible");
    if (banner) {
      banner.remove();
    }

    const needsclickElements = document.querySelectorAll("body.awt-bab-open .needsclick");
    needsclickElements.forEach((element) => {
      element.remove();
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    removeElements();

    const observer = new MutationObserver(removeElements);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

if (window.location.href.includes("pages/meal-delivery")) {
  const replaceOrderText = () => {
    if (window.orderTextReplaced) return;

    const orderBelow = document.querySelector("body.template-page-meal-delivery #main > div:nth-child(1) h2");
    if (orderBelow) {
      orderBelow.innerHTML = `<a class="awt-order-here" href="/tools/bundle-subscriptions/bundle/8242242912431?product=build-your-meal-plan">Order Here</a>`;
      window.orderTextReplaced = true;
    }
  };

  replaceOrderText();
  document.addEventListener("DOMContentLoaded", replaceOrderText);
}

// step 3 hack
if (window.location.href.includes("tools/bundle-subscriptions/bundle")) {
  (() => {
    const update = () => document.body.classList.toggle("step3", !!document.querySelector("main.bundle-create-content.step3"));
    const watchTarget = (target) => new MutationObserver(update).observe(target, { childList: true, subtree: true });
    const findContainer = () => {
      const container = document.querySelector("div.bundleapp-modal__container--complete-screen");
      if (container) {
        watchTarget(container);
        update();

        const observer = new MutationObserver(() => {
          const backdrop = document.querySelector("body.awt-bab-open .awtomic-select-dropdown .multi-select-backdrop");
          document.body.classList.toggle("awt-hide-footer", !!backdrop);
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }
    };
    findContainer();
    new MutationObserver(findContainer).observe(document.body, { childList: true, subtree: true });
  })();
}

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");
}
